<template>
  <shared-provide-variation :variation="variation" :fromModule="fromModule" :toModule="toModule" @change="emitToParent">

    <form-group label="EAN" :columns="6" :error="getError('ean', variation.sku)" :required="false" slot="ean">
      <input class="form-input" type="text" v-model="variation.ean" :disabled="disabledInputs()">
    </form-group>

    <div class="divider"><span>Atributos</span></div>

    <div class="l-row">
      <form-group label="Gênero" :columns="3" :error="getError('gender', variation.sku)">
        <select v-model="variation.gender" class="form-select" :disabled="variation.status === 'sent' || variation.status === 'error'">
          <option :value=null>Escolha</option>
          <option value="male">
            {{ $t('skyhub.gender.male.label') }}
          </option>
          <option value="female">
            {{ $t('skyhub.gender.female.label') }}
          </option>
          <option value="unisex">
            {{ $t('skyhub.gender.unisex.label') }}
          </option>
        </select>
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('color') !== -1" :label="$t(`color.label`)" :columns="3" :error="getError('attributes.color', variation.sku)" :required="false">
        <input class="form-input" type="text" v-model="variation.attributes['color']" :disabled="disabledInputs()">
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('voltage') !== -1" :label="$t(`voltage.label`)" :columns="3" :error="getError('attributes.voltage', variation.sku)" :required="true">
        <input class="form-input" type="text" v-model="variation.attributes['voltage']" :disabled="disabledInputs()">
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('size') !== -1" :label="$t(`size.label`)" :columns="3" :error="getError('attributes.size', variation.sku)" :required="true">
        <input class="form-input" type="text" v-model="variation.attributes['size']" :disabled="disabledInputs()">
      </form-group>

      <form-group :label="$t(`Anatel.label`)" :columns="3">
        <input class="form-input" type="text" v-model="variation.attributes['Anatel']" :disabled="disabledInputs()">
      </form-group>
    </div>
  </shared-provide-variation>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    props: {
      variation: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    methods: {
      disabledInputs () {
        return this.variation.status === 'sent' || this.variation.status === 'error'
      },
      emitToParent (value) {
        this.$emit('change', value)
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    components: {
      SharedProvideVariation,
      FormGroup
    }
  }
</script>



// WEBPACK FOOTER //
// Variation.vue?8aacdddc